import * as Types from '../../types/graphql.gen';

import { gql } from '@apollo/client';
export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationLoginCompletedFragment = { __typename?: 'LoginNavigationLoginCompleted', currentLoginPharmacyType: Types.CurrentLoginPharmacy, redirectUri?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireChangeDefaultPasswordFragment = { __typename?: 'LoginNavigationRequireChangeDefaultPassword', redirectTo?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationFragment = LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationLoginCompletedFragment | LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireChangeDefaultPasswordFragment;

export const LoginNavigationUseHandleLoginNavigationLoginNavigationFragmentDoc = gql`
    fragment LoginNavigation_UseHandleLoginNavigation_LoginNavigation on LoginNavigation {
  ... on LoginNavigationLoginCompleted {
    currentLoginPharmacyType
    redirectUri
  }
  ... on LoginNavigationRequireChangeDefaultPassword {
    redirectTo
  }
}
    `;